









import { computed, defineComponent, toRefs, ref, watch } from '@vue/composition-api';
import EmptyCard from '@tt4b/ttam-assets/src/images/creative/empty-card.png';

const name = 'ttam-interactive-add-on-preview-thumbnail';
export default defineComponent({
  props: {
    thumbNail: {
      type: String,
      default: '',
    },
    cardType: {
      type: Number,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { thumbNail, isLoading } = toRefs(props);
    const _loading = computed(() => isLoading.value);
    const isEmpty = computed(() => !thumbNail.value);

    return {
      name,
      _loading,
      EmptyCard,
      isEmpty,
    };
  },
});
